import * as React from 'react';
import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';
import { grey13Opacity38 } from 'app/components/ThemeProvider/colors';

const BookmarkIcon = ({ sx, ...props }: SvgIconProps) => {
  return (
    <SvgIcon
      viewBox="0 0 22 22"
      sx={{ '&.MuiSvgIcon-root': { height: '22px', width: '22px' }, fill: 'transparent', ...sx }}
      {...props}
    >
      <path
        d="M4.5835 7.15C4.5835 5.60986 4.5835 4.83978 4.88323 4.25153C5.14688 3.73408 5.56758 3.31338 6.08502 3.04973C6.67328 2.75 7.44335 2.75 8.9835 2.75H13.0168C14.557 2.75 15.327 2.75 15.9153 3.04973C16.4327 3.31338 16.8534 3.73408 17.1171 4.25153C17.4168 4.83978 17.4168 5.60986 17.4168 7.15V19.25L11.0002 15.5833L4.5835 19.25V7.15Z"
        stroke={props.color === 'warning' ? 'black' : props.color === 'secondary' ? grey13Opacity38 : 'white'}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
};

export default BookmarkIcon;
